import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  // No real stories yet -> hide the section entirely (never fabricate testimonials).
  if (items.length === 0) return null;

  return (
    <section className="py-20 sm:py-28 border-t border-ink/10" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-flame mb-4">Real Roamies. Real Stories.</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95]">
            From the group chat.
          </h2>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <motion.figure
              key={t.id}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
              data-testid={`testimonial-${t.id}`}
              className="bg-white border border-black/10 p-7 rotate-[-0.5deg] hover:rotate-0 transition-transform duration-300 shadow-brutal"
            >
              {t.image && (
                <img src={t.image} alt={t.first_name} className="w-14 h-14 object-cover border border-ink/10 mb-4" />
              )}
              <blockquote className="text-sm text-ink/80 leading-relaxed">“{t.quote}”</blockquote>
              <figcaption className="mt-4">
                <p className="font-bold text-sm">{t.first_name}{t.handle ? <span className="text-flame font-semibold"> · {t.handle}</span> : null}</p>
                {t.trip && <p className="text-xs text-ink/50 uppercase tracking-widest mt-1">{t.trip}</p>}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
